import styled from 'styled-components';

interface SignInOutLinkProps {
    isLargeLink: boolean;
}

export const SignInOutLink = styled.a<SignInOutLinkProps>`
    color: #FFFFFF;
    text-decoration: none;
    cursor: pointer;

    ${({ isLargeLink }) => isLargeLink
        ? `
        font-size: 28px;
        font-weight: 600;
        text-transform: uppercase;
        `
        : `
        font-weight: 400;
        font-size: 14px;
    `}
`;
